import React from 'react';
import { useTranslation } from 'react-i18next';

const HowItWorksSection = () => {
  const { t } = useTranslation();

  const steps = [
    {
      icon: '🗂️',
      title: t('how.steps.0.title'),
      desc: t('how.steps.0.desc'),
    },
    {
      icon: '📷',
      title: t('how.steps.1.title'),
      desc: t('how.steps.1.desc'),
    },
    {
      icon: '🧭',
      title: t('how.steps.2.title'),
      desc: t('how.steps.2.desc'),
    },
    {
      icon: '🎁',
      title: t('how.steps.3.title'),
      desc: t('how.steps.3.desc'),
    },
  ];

  return (
    <section
      id="how-it-works"
      className="bg-gray-50 dark:bg-gray-900 py-20 px-4 md:px-10 text-center"
    >
      <h2
        className="text-3xl md:text-4xl font-bold mb-4 text-gray-800 dark:text-white"
        data-aos="fade-up"
      >
        {t('how.title')}
      </h2>
      <p
        className="text-gray-600 dark:text-gray-300 mb-14 text-sm max-w-xl mx-auto"
        data-aos="fade-up"
        data-aos-delay="100"
      >
        {t('how.subtitle')}
      </p>

      <div className="max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 text-left">
        {steps.map((step, idx) => (
          <div
            key={idx}
            data-aos="fade-up"
            data-aos-delay={idx * 150}
            className="bg-white dark:bg-gray-800 border border-gray-100 dark:border-gray-700 p-6 rounded-xl shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-md"
          >
            <div className="text-4xl mb-4">{step.icon}</div>
            <h3 className="font-semibold text-lg text-gray-800 dark:text-white mb-2">
              {step.title}
            </h3>
            <p className="text-sm text-gray-600 dark:text-gray-300">{step.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default HowItWorksSection;
